import { ChildrenOnlyProp } from "./commonProps";
import { useLocation } from "react-router-dom";
import { SignUpHeader } from "../App/common/SignUpHeader";
import { TopBar } from "../App/common/TopBar";

const WHITE_BG_URLS = [
  "/auth/sign-up",
  "/account/application/step/1",
  "/account/application/step/2",
  "/account/application/step/3",
  "/account/application/step/4",
  "/account/application/step/5",
  "/account/application/step/6",
  "/account/application/step/7",
  "/account/application/step/8",
];

export const Page: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const location = useLocation();

  return (
    <div
      className={`min-h-screen flex flex-col justify-start overflow-auto ${
        WHITE_BG_URLS.includes(location.pathname) && "bg-white"
      }`}
    >
      {WHITE_BG_URLS.includes(location.pathname) ? <SignUpHeader /> : <TopBar />}
      {children}
    </div>
  );
};
